module.exports = __webpack_public_path__ + "img/logo.9167ce74.svg";